import { useMissionStorage, useMissionsTranslation } from '../../../../ui/hooks';
import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useCallback } from 'react';
import { missionWizardSteps } from '../components/missionWizardSteps';
import { useAdditionalSteps } from './useAdditionalSteps';
export const useCreateNewMission = () => {
    const additionalSteps = useAdditionalSteps();
    const { t } = useMissionsTranslation();
    const missionStorage = useMissionStorage();
    const handleSubmit = useCallback((data) => {
        return missionStorage
            .post({
            action: 'create',
            data: data,
        })
            .then((mission) => {
            showInfoSnackbar({
                message: t('missions.created'),
                autoHideDuration: 2000,
            });
            return mission;
        })
            .catch(handleErrorSnackbar);
    }, [t, missionStorage]);
    const wizardConfig = {
        steps: [...missionWizardSteps, ...(additionalSteps !== null && additionalSteps !== void 0 ? additionalSteps : [])],
        title: t('missions.launchNewMission'),
        submitButtonLabel: t('missions.launchAndAddShifts'),
        closeWizardContent: t('wizard.closeWizardContentNew'),
        onSubmit: handleSubmit,
    };
    return {
        wizardConfig,
    };
};
